import React from "react"
import { capitalize } from "@mimber/shared"
import { Modal } from "@mimber/ui-web"
import { QuickCreateCommunicationTemplateForm } from "@/components/forms/QuickCreateCommunicationTemplateForm"
import type { QuickCreateCommunicationTemplateModalProps } from "./QuickCreateCommunicationTemplateModal.types"

export const QuickCreateCommunicationTemplateModal: React.FunctionComponent<
  QuickCreateCommunicationTemplateModalProps
> = ({ channel, onSuccess, ...modalProps }) => {
  const channelLabel = capitalize(channel)

  return (
    <Modal
      footer={null}
      title={`Quick Create ${channelLabel} Template`}
      width={640}
      {...modalProps}
    >
      {(close) => (
        <QuickCreateCommunicationTemplateForm
          channel={channel}
          onSuccess={(template) => {
            close()
            onSuccess?.(template)
          }}
          onCancel={close}
        />
      )}
    </Modal>
  )
}
